import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { IOrdinalProps, ordinalColors } from './shared.styles';
import { ChartConstants } from './util';

export const LineGroup = styled.g`
    clip-path: url(#chart-background);
`;
export const LineShadow = styled.polygon`
    opacity: 0.4;
    stroke: transparent;
    fill: url(#lineGroupGradient);
`;
export const Line = styled.g``;
export const LinePath = styled.path<IOrdinalProps>`
    fill: transparent;
    stroke: ${ordinalColors};
    stroke-width: 2px;
`;
export const LineDot = styled.circle<IOrdinalProps>`
    fill: ${Variables.Colors.white};
    stroke: ${ordinalColors};
    stroke-width: ${ChartConstants.dotStrokeWidth};
`;
export const GradientTop = styled.stop`
    stop-opacity: 1;
`;
export const GradientMiddle = styled.stop`
    stop-opacity: 0.7;
`;
export const GradientBottom = styled.stop`
    stop-opacity: 0;
`;
export const LinearGradient = styled.linearGradient``;
export const GradientDefs = styled.defs`
    ${GradientTop} {
        stop-color: ${Variables.Colors.sunset100};
    }
    ${GradientMiddle},
    ${GradientBottom} {
        stop-color: ${Variables.Colors.sunset75};
    }
`;
